import { render } from "./leaveItem.vue?vue&type=template&id=b7d063e0&scoped=true"
import script from "./leaveItem.vue?vue&type=script&lang=js"
export * from "./leaveItem.vue?vue&type=script&lang=js"

import "./leaveItem.vue?vue&type=style&index=0&id=b7d063e0&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator.DESKTOP-7G84OHA\\Desktop\\dduh-active-webh5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d063e0"]])

export default __exports__